module.exports = __webpack_public_path__ + "img/zhishe.00b46b55.png";